import { configuration } from '../configs/config'

const { backendBaseUrl } = configuration

export const resourceUrl = (resource: string, resourceId?: string) => {
    const id = resourceId != null ? `/${resourceId}` : ''
    return `${backendBaseUrl}/api/${resource}${id}`
}
